import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.uni.driver';
import { buttonDriverFactory } from '../Button/Button.uni.driver';
import { dataHooks } from './constants';
import { findByHook } from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';

export const announcementModalLayoutDriverFactory = (base: UniDriver) => {
  const getLink = () => buttonDriverFactory(findByHook(base, dataHooks.link));

  return {
    ...baseModalLayoutDriverFactory(base),

    /** Returns if the link component text content */
    getLinkText: () => getLink().getButtonTextContent(),

    /** Clicks the link component */
    clickLink: async () => getLink().click(),
  };
};

export type AnnouncementModalLayoutUniDriver = ReturnType<
  typeof announcementModalLayoutDriverFactory
>;
